export const getSudokuId = (sudoku) => {
    if (sudoku) {
        return sudoku.dataset.postId ? +sudoku.dataset.postId : 0;
    }
    return 0;
};
